//@flow
import React, { Component } from 'react';

import { TrekOverviewIcon as Icons } from '../../../../constants/icons';
import EditButton from '../../NewEditButton';
import { componentNames as editorNames } from '../../TrekOverviewModal';
import withTrekPermission from '../../../../HOCs/withTrekPermission';

type Props = {
  minSize: number,
  maxSize: number,
  followers: Array<string>,
  isGuidedOwner: boolean,
};

type IconCompProps = {
  type: string,
};

const IconComp = ({ type }: IconCompProps) => <i className={Icons[type]} />;

class BasicInfoViewer extends Component<Props> {
  render() {
    const { minSize, maxSize, /*followers,*/ isGuidedOwner } = this.props;

    // const noOfPeopleJoined = followers.length;
    // const seatsRemaining = maxSize - noOfPeopleJoined;

    const basicInfoComp = [
      { icon: 'sun', label: 'Minimum Size', value: minSize },
      { icon: 'sun', label: 'Maximum Size', value: maxSize },
      // { icon: 'sun', label: 'Seats Remaining', value: seatsRemaining, },
      // {
      //   icon: 'group',
      //   label: 'People Joined',
      //   value: noOfPeopleJoined,
      //   extraComp: noOfPeopleJoined ? (
      //     <span onClick={this.openFollowersList}>view</span>
      //   ) : null,
      // },
    ];

    return (
      <div className="white-panel">
        <h2>
          BASIC INFORMATION
          {isGuidedOwner && (
            <EditButton editorName={editorNames.BasicInfoEditor} openModal={false} />
          )}
        </h2>
        <ul className="imp-info clearfix">
          {basicInfoComp.map(v => (
            <li key={v.label}>
              <div className="count-holder">
                <div className="count-wrap">
                  <h4>{v.value}</h4>
                  <div className="icon-holder">
                    <IconComp type={v.icon} />
                    {v.label}
                    {v.extraComp}
                  </div>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

export default withTrekPermission(BasicInfoViewer);



// WEBPACK FOOTER //
// ./src/components/TrekDetail/Viewers/BasicInfo/BasicInfoViewer.jsx